//获取定位
function getLocalData() {
    return new Promise((resolve, reject) => {
        let url = 'https://apis.map.qq.com/ws/location/v1/ip';
        const data = {
            key: "WA7BZ-DKECJ-EU7FL-FMCFT-TA5TS-GPFNG",
            output: "jsonp"
        };

        // 1.初始化url
        let dataString = url.indexOf('?') === -1 ? '?' : '&'
        let callbackName = `jsonpCB_${Date.now()}`;
        url += `${dataString}callback=${callbackName}`
        if (data) {

            // 2.有请求参数，依次添加到url
            for (let k in data) {
                url += `&${k}=${data[k]}`
            }
        }


        let scriptNode = document.createElement('script');
        scriptNode.src = url;

        // 3. callback
        window[callbackName] = (result) => {
            result ? resolve(result) : reject('没有返回数据');
            delete window[callbackName];
            document.body.removeChild(scriptNode);
        }

        // 4. 异常情况
        scriptNode.addEventListener('error', () => {
            reject('接口返回数据失败');
            delete window[callbackName];
            document.body.removeChild(scriptNode);
        }, false)


        // 5. 开始请求
        document.body.appendChild(scriptNode)
    })
}

const {ElMessage} = ElementPlus;

async function test() {
    ElMessage({
        showClose: true,
        message: 'Oops, this is a error message.',
        type: 'error',
    })
}

async function postRequest(url, data) {
    try {
        // 发送POST请求并获取响应
        const response = await axios.post(url, data);
        console.log("postRequest")
        if (-3 === response.data.code) {
            let timer = null;
            ElMessage({
                showClose: true,
                message: '请先登录',
            })
            timer = setTimeout(() => {
                clearTimeout(timer);
                timer = null;
                console.log("跳转到登录页面")
                location.href = jkas.url("/login/index");
            }, 1000)
        }
        // 返回响应数据
        return response.data;
    } catch (error) {
        // 如果发生错误，打印错误信息并返回空
        console.error('Error in postRequest:', error);
        ElMessage({
            showClose: true,
            message: "请求出错",
            type: 'error',
        })
        return null;
    }
}
